import React, { useEffect, useState } from 'react';
import axios from 'axios';
import _ from 'underscore';
import { history } from '../../redux/store';
import setting from '../../config/setting';
import { Spin, Space, Row, Col, Button, Card, Form, notification, Select, Upload, DatePicker, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

const FormItem = Form.Item;
const { Option } = Select;
const { Dragger } = Upload;


const props = {
  name: 'file',
  action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  headers: {
    authorization: 'authorization-text'
  },
  onChange(info) {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  }
};

const AddCovidTestView = () => {
  const [eventid, setEventid] = useState('123');
  const [compNameN, setcompName] = useState('');
  const [location, setLocation] = useState('');
  const [employee, setEmployee] = useState('');
  const [sex, setSex] = useState('');
  const [dob, setDob] = useState('');
  const [emailN, setemail] = useState('');
  const [test_date, setTestDate] = useState('');
  const [test_type, setTestType] = useState('');
  const [photo_pdf, setPhotoPdf] = useState('');
  const [testing_status, setTesting_Status] = useState('');
  const [testing_result, setTesting_result] = useState('Negative');
  const [loader, setLoader] = useState(false);
  const [bool, setBool] = useState(false);
  const [boolNew, setBoolNew] = useState(false);
  const [boolN, setBoolN] = useState(false);
  const [boolNe, setBoolNe] = useState(false);
  const [errors, setErrors] = useState({
    test_date: '',
    photo_pdf: '',
    test_type: '',
    testing_result: ''
  });

  const covidTestTypes = ['Antigen', "RT-PCR", "Antibody"];

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  useEffect(() => {
    setBool(true);
    setBoolNew(true);
    setBoolN(true);
    setBoolNe(true);
  }, []);

  function addTestDate(event, date) {
    console.log('Test Date', date);
    setTestDate(date);
    let errorsCopy = { ...errors };
    errorsCopy['test_date'] = '';
    setErrors(errorsCopy);
  }

  function addTestType(event) {
    console.log('Test Name', event);
    setTestType(event);
    let errorsCopy = { ...errors };
    errorsCopy['test_type'] = '';
    setErrors(errorsCopy);
  }

  function addPhotoPdf(file, fileList) {
    console.log('photo_pdf', file);
    setPhotoPdf(file);
    let errorsCopy = { ...errors };
    errorsCopy['photo_pdf'] = '';
    setErrors(errorsCopy);
    // setPhotoPdf(event.target.files[0]);
  }

  function addTestingResult(event) {
    console.log('Testing Result', event);
    setTesting_result(event);
    let errorsCopy = { ...errors };
    errorsCopy['testing_result'] = '';
    setErrors(errorsCopy);
  }

  function saveTest() {
    console.log(
      'saveTest parameters ' +
      eventid +
      compNameN +
      location +
      employee +
      sex +
      dob +
      emailN +
      test_date +
      test_type +
      photo_pdf +
      testing_status +
      testing_result
    );

    if (!loader) {
      let employeeData = JSON.parse(localStorage.getItem('employeeInfo'));

      if (test_date && test_type && testing_result && photo_pdf) {
        setLoader(true);
        const formData = new FormData();
        formData.append('photo_pdf', photo_pdf);
        formData.append('eventid', eventid);
        formData.append('compNameN', employeeData.company[0]);
        formData.append('location', employeeData.emp_location[0]);
        formData.append('employee', employeeData.id);
        formData.append('sex', employeeData.sex);
        formData.append('dob', employeeData.dob);
        formData.append('emailN', employeeData.email);
        formData.append('first_name', employeeData.first_name);
        formData.append('test_date', test_date);
        formData.append('test_type', test_type);
        formData.append('testing_result', testing_result);
        formData.append('testing_status', testing_status);

        const headers = {
          'Content-Type': 'multipart/form-data'
        };

        axios({
          method: 'post',
          url: setting.serverUrl + '/api/saveCovidTesting',
          data: formData,
          headers
        }).then((response) => {
          console.log('Respone from saveCovidTesting ', response.data);
          setLoader(false);
          if (response && response.status === 200) {

            // if (response.data && response.data.error) {
            //   notification['error']({
            //     message: 'Error',
            //     description: response.data.error
            //   })
            // }

            // if (response.data && response.data.success)
             {
              notification['success']({
                message: 'Success',
                description: 'Information recorded!'
              })
              history.push({ pathname: `/vertical/CovidTesting` });
            }

          } else {
            notification['error']({
              message: 'Error',
              description: 'There is some technical issue. Please try again later.'
            })
          }

       
        });
      } else {
        let errorsCopy = { ...errors };
        if (!test_date) {
          errorsCopy['test_date'] = 'This field is required';
          setErrors(errorsCopy);
          setLoader(false);
        }
        if (!test_type) {
          errorsCopy['test_type'] = 'This field is required';
          setErrors(errorsCopy);
          setLoader(false);
        }
        if (!testing_result) {
          errorsCopy['testing_result'] = 'This field is required';
          setErrors(errorsCopy);
          setLoader(false);
        }
        if (!photo_pdf) {
          errorsCopy['photo_pdf'] = 'This field is required';
          setErrors(errorsCopy);
          setLoader(false);
        }
      }
    }
  }

  
  return (
    <div style={{ padding: 30 }}>
      <div>
        <Button
          size='small'
          style={{ backgroundColor: 'rgb(61 88 106)', color: 'white', marginTop: 0, padding: 10 }}
          onClick={() => history.goBack()}
        >
          Back
        </Button>
      </div>
      <Row>
        <Col span={6}>
          <h3 style={{ padding: 10, textAlign: 'left' }}>Add Covid Test</h3>
        </Col>
        <Col span={8}></Col>
      </Row>
      {bool && boolNew && boolN && boolNe ? (
      
        <div style={{ background: 'white', borderRadius: 20, padding: 30 }}>
          <div className='row'>
            <div className='col-md-12 col-sm-12'>
              <Card>
                <Form layout='vertical'>
                  <div className='row'>
                    <div className='col-md-6 col-sm-12'>
                      <FormItem label='Covid Test Date'>
                        <DatePicker
                          style={{ width: '100%' }}
                       
                          onChange={addTestDate}
                        />

                        <span style={{ color: 'red' }}>{errors['test_date']}</span>
                      </FormItem>
                    </div>
                    <br />
                    <div className='col-md-6 col-sm-12'>
                      <FormItem label='Covid Test Type'>
                        <Select 
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
                        }
                        onChange={addTestType}>
                          {covidTestTypes.map((test, i) => (
                            <Option value={test} key={i}>
                              {' '}
                              {test}{' '}
                            </Option>
                          ))}
                        </Select>

                     

                        <span style={{ color: 'red' }}>{errors['test_type']}</span>
                      </FormItem>
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <div className='col-md-6 col-sm-12'>
                      <FormItem label='Result Type'>
                        <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
                        }
                          defaultValue='Negative'
                          onChange={addTestingResult}
                          style={{ background: 'white', borderRadius: '25px' }}
                        >
                          <Option value='Positive'>Positive</Option>
                          <Option value='Negative'>Negative</Option>
                        </Select>

                        <span style={{ color: 'red' }}>{errors['testing_result']}</span>
                      </FormItem>
                    </div>
                    <div className='col-md-6 col-sm-12'>
                      <FormItem label='Upload Photo/PDF'>
                        <Dragger multiple={true}
                          beforeUpload={addPhotoPdf}
                        >
                          <p className='ant-upload-drag-icon'>
                            <InboxOutlined />
                          </p>
                          <p className='ant-upload-text'>
                            Click or drag file to this area to upload
                          </p>
                        </Dragger>
                        <span style={{ color: 'red' }}>{errors['photo_pdf']}</span>
                      </FormItem>
                    </div>
                    <br /> <br />
                  </div>
                  <br />

                  <br />
                  <br />
                  <div className='row'>
                    <div className='col-md-4 col-sm-4'></div>
                    <div className='col-md-5 col-sm-5'>
                      <Button
                        type='primary'
                        style={{ width: '70%', background: 'rgb(66,90,129)' }}
                        onClick={saveTest}
                      >
                        Save
                      </Button>
                      {loader && (
                        <Space size='middle' style={{ marginLeft: 20 }}>
                          <Spin size='large' />
                        </Space>
                      )}
                    </div>
                  </div>
                </Form>
              </Card>
            </div>
          </div>
        </div>
      ) : (
        <Row>
          <Col span={10}></Col>
          <Col span={8}>
            <Space size='middle' style={{ marginTop: 10 }}>
              <Spin size='large' />
            </Space>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default AddCovidTestView;
